import { motion } from 'motion/react'
import { pieCircle } from './Flow05Forever.css'

type ForeverPieChartProps = {
  discount: number
  total: number
}

export function ForeverPieChart({ discount, total }: ForeverPieChartProps) {
  const degrees = (discount / total) * 360

  return (
    <motion.div
      className={pieCircle}
      initial={{ '--pie-fill-degrees': `${degrees}deg` }}
      animate={{ '--pie-fill-degrees': `${degrees}deg` }}
      transition={{ duration: 0.8, ease: [0.25, 0.1, 0.25, 1] }}
    />
  )
}
